import { useQuery } from '@tanstack/react-query';
import { projectService } from '@services/project';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const PROJECTS_QUERY_KEY = 'projects';

export const useProjects = () => {
  const { userId } = useAppSelector((state: RootState) => state.user);

  return useQuery({
    queryKey: [PROJECTS_QUERY_KEY, userId],
    queryFn: () => projectService.getProjectsByUser(userId!),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
